export const Role = {
  Seller: "Company",
  Owner: "Owner",
  Presenter: "Presenter"
};
